<template>
  <div id="app" class="app">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!($route.meta && $route.meta.keepAlive)"/>
  </div>
</template>
<script>

export default {
  name: 'App',
  data () {
    return {
      wxLoaded: false,
    }
  },
  computed: {},
  watch: {},
  created () {

  },
  methods: {},

}
</script>
<style lang="less">
.app {
  width: 100vw;
  min-height: 100vh;
  font-size: 0.16rem;

  & > {
    .fadeIn, .fadeOut {
      animation-duration: 0.5s;
    }
  }
}

</style>
